








































import VueNumeric from '../inputs/VueNumeric.vue'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon,
    VueNumeric
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    minus: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: 2
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
export default class InputMoney extends Vue {
}
